export default __webpack_public_path__ + "static/media/map.a1158fa9.svg";